import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  HostListener,
  OnChanges,
  OnDestroy,
} from '@angular/core';
import { SessionService } from '@tech-services/session.service';
import { ProfileportfolioService } from '@tech-services/profileportfolio.service';
import { Subject, takeUntil, timer } from 'rxjs';
import { DeviceDetectorService, PortfolioDataInterface } from '@techrules/portallib';
import { TranslateService } from '@ngx-translate/core';
import { MatTabGroup } from '@angular/material/tabs';
import { CommonService } from '@tech-services/common.service';
import { AppConfig } from '@tech-utils/app-config.service';

export enum PortfolioDataTabEnum {
  Summary = 0,
  Positions = 1,
  Composition = 2,
  Trades = 3,
  Activities = 4,
  Credits = 5,
  Diagnosis = 6,
  Risk = 7,
  Commissions = 8,
}

@Component({
  selector: 'tech-portfolio-data',
  templateUrl: './portfolio-data.component.html',
  styleUrls: [
    './portfolio-data.component.scss',
    './portfolio-data-shared-styles.scss',
  ],
})
export class PortfolioDataComponent implements OnInit, OnChanges, OnDestroy {
  @Input() portfolioCode: string;
  portfolioData: PortfolioDataInterface;

  private _tabIndex = 0;
  //Retrieve the selected tab index (number)
  public get tabIndex() {
    return this._tabIndex;
  }

  //Set the selected tab index depending on the PortfolioDataEnum item provided (some tabs can be hidden)
  public set tabIndex(value) {
    //Receives a PortfolioDataEnum data and returns the element index in the tabMap.
    this._tabIndex = this.getSelectedTabIndex(value);
  }

  //List with the tabs added to the tabGroup.
  tabMap: Map<PortfolioDataTabEnum, string> = new Map<
    PortfolioDataTabEnum,
    string
  >();

  //List with the tab names for the labels.
  tabs = [];

  isMobile = false;

  @ViewChild('contSumary', { static: true }) sumaryComponent: ElementRef;
  @ViewChild('contPositions', { static: true }) posiComponent: ElementRef;
  @ViewChild('contCompositions', { static: true }) compoComponent: ElementRef;
  @ViewChild('contTrades', { static: true }) tradesComponent: ElementRef;
  @ViewChild('contActividades', { static: true })
  actividadesComponent: ElementRef;
  @ViewChild('contCredits', { static: true }) creditsComponent: ElementRef;
  @ViewChild('contDiagnosis', { static: true }) diagnosisComponent: ElementRef;
  @ViewChild('contRisk', { static: true }) riskComponent: ElementRef;
  @ViewChild('contCommissions', { static: true }) commissionsComponent: ElementRef;
  @ViewChild('stickyMenu', { static: true }) stickyMenu: ElementRef;
  @ViewChild('contentStickyMenu', { static: true })
  contentStickyMenu: MatTabGroup;
  //@ViewChild('controlStickyMenu', { static: true }) controlStickyMenu: ElementRef;
  private unsubscribe$ = new Subject<void>();

  //Show/hide tabs
  sumary = true;
  positions = false;
  compositions = false;
  trades = false;
  actividades = false;
  credits = false;
  diagnosis = false;
  risk = false;
  commissions = false;

  sumaryFirstLoad = true;
  positionsFirstLoad = true;
  compositionsFirstLoad = true;
  tradeFirstLoad = true;
  actividadesFirstLoad = true;
  creditsFirstLoad = true;
  diagnosisFirstLoad = true;
  riskFirstLoad = true;
  commissionsFirstLoad = true;

  //private clickTabsMenu:boolean = false;
  isSticky = false;
  private scrWidth: number;
  private timer50 = timer(50);
  withClick = false;

  //Show/hide tabs considering AppSetting config.
  showActivities = false;
  hasCredits = false; //only show credits if available
  showDiagnosis = false; //disabled by default
  showRisk = false; //disabled by default
  showCommissions = false; //disabled by default

  private stopScrollEvent = false;
  initialDate = '';
  endDate = '';

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.isMobile = this.deviceService.isMobile();
    this.loadTab(this.tabIndex);
  }

  constructor(
    private sessionService: SessionService,
    private commonService: CommonService,
    private profilePortfolioService: ProfileportfolioService,
    private translate: TranslateService,
    private readonly deviceService: DeviceDetectorService
  ) {
    this.isMobile = this.deviceService.isMobile();
  }

  ngOnInit() {
    //Apply AppSetting config
    this.risk = false; //disabled by default
    this.showDiagnosis = false;//AppConfig.settings.diagnosisModule;
    this.showCommissions = false;//AppConfig.settings.commissionsModule;
    //Hide tabs until data is loaded
    this.hideAllTabs();
    this.checkIfHasCredits();
  }

  checktab() {
    let selectedtab = AppConfig.settings.defaultPortfolioFileTab;
    let tabseñalado;
    switch (selectedtab) {
      case 'summary':
        tabseñalado = PortfolioDataTabEnum.Summary;
        break;
      case 'positions':
        tabseñalado = PortfolioDataTabEnum.Positions;
        break;
      case 'compositions':
        tabseñalado = PortfolioDataTabEnum.Composition;
        break;
      case 'trades':
        tabseñalado = PortfolioDataTabEnum.Trades;
        break;
      case 'activities':
        tabseñalado = PortfolioDataTabEnum.Activities;
        break;
      case 'credits':
        tabseñalado = PortfolioDataTabEnum.Credits;
        break;
      case 'diagnosys':
        tabseñalado = PortfolioDataTabEnum.Diagnosis;
        break;
      case 'risk':
        tabseñalado = PortfolioDataTabEnum.Risk;
        break;
      default:
        tabseñalado = PortfolioDataTabEnum.Summary;
        break;
    }
    this.tabIndex = tabseñalado;
    this.loadTab(this.getSelectedTabIndex(tabseñalado));
  }

  ngOnDestroy() {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  ngOnChanges(): void {
    if (
      this.sessionService.portfolioCode !== '' &&
      this.sessionService.portfolioCode !== 'undefined' &&
      this.commonService.isProductiveSource.getValue()
    ) {
      this.profilePortfolioService.getPortfolioData().subscribe((data) => {
        this.portfolioData = data;
        this.initialDate = this.portfolioData.InitialDate;
        let date = new Date();
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();

        this.endDate = `${year}-${month}-${day}`;

        this.showActivities = data.ServiceModelBehavior === 'ROBOADVISOR';
        this.loadTabs();

        this.profilePortfolioService.portfolioAnalysisHasCredits$.subscribe(
          (value) => {
            this.hasCredits = value;
            //refresh
            this.loadTabs();
          }
        );

        // this.profilePortfolioService.portfolioDataSource.next(data);

        if (this.isMobile) {
          this.tabIndex = PortfolioDataTabEnum.Summary;
          this.enableAllTabs();
        }

        this.commonService.loading$.emit(false);
      });
    }
  }

  /**
   * Append the required tabs to the tabMap linked to the tabGroup
   */
  initTabs() {
    this.tabMap = new Map<PortfolioDataTabEnum, string>();

    //Summary
    this.translate.get('k000030').subscribe((text: string) => {
      this.tabMap.set(PortfolioDataTabEnum.Summary, text);
    });

    //Positions
    this.translate.get('k000129').subscribe((text: string) => {
      this.tabMap.set(PortfolioDataTabEnum.Positions, text);
    });

    //Composition
    this.translate.get('k000130').subscribe((text: string) => {
      this.tabMap.set(PortfolioDataTabEnum.Composition, text);
    });

    //Trades/Activities
    if (!this.showActivities) {
      //Trades
      this.translate.get('k000132').subscribe((text: string) => {
        this.tabMap.set(PortfolioDataTabEnum.Trades, text);
      });
    } else {
      //Activities
      this.translate.get('k002951').subscribe((text: string) => {
        this.tabMap.set(PortfolioDataTabEnum.Activities, text);
      });
    }

    //Credits/Liabilities
    if (this.hasCredits) {
      this.translate.get('k004011').subscribe((text: string) => {
        this.tabMap.set(PortfolioDataTabEnum.Credits, text);
      });
    }

    //Diagnosis
    if (this.showDiagnosis) {
      this.translate.get('k004286').subscribe((text: string) => {
        this.tabMap.set(PortfolioDataTabEnum.Diagnosis, text);
      });
    }

    //Risk
    if (this.showRisk) {
      this.translate.get('k001236').subscribe((text: string) => {
        this.tabMap.set(PortfolioDataTabEnum.Risk, text);
      });
    }

    //Commissions
    if (this.showCommissions) {
      this.translate.get('k000163').subscribe((text: string) => {
        this.tabMap.set(PortfolioDataTabEnum.Commissions, text);
      });
    }

    // window.addEventListener('scroll', this.scrollevent, true);

    //If set, select activities tab by default
    if (this.sessionService.activityInit) {
      this.tabIndex = PortfolioDataTabEnum.Activities;
      this.sessionService.activityInit = false;
    }

    //Load data texts into tabs to be shown in tab labels
    this.tabs = Array.from(this.tabMap.values());
  }

  /**
   * Load tabs with data and show them all.
   */
  loadTabs() {
    this.initTabs();
    this.checktab();
    this.showAllTabs();
  }

  /**
   * Hide all tabs in the tabGroup.
   */
  hideAllTabs() {
    setTimeout(() => {
      this.tabMap.forEach((value, key) => {
        if (this.getTabElement(key))
          this.getTabElement(key).style.display = 'none';
      });
    });
  }

  /**
   * Show all tabs in the tabGroup.
   */
  showAllTabs() {
    setTimeout(() => {
      this.tabMap.forEach((value, key) => {
        if (this.getTabElement(key))
          this.getTabElement(key).style.display = null;
      });
    });
  }

  /**
   * Retrieves HTML tab element.
   * @param pos Index of the element to be retrieved.
   * @returns HTML element.
   */
  getTabElement(pos) {
    return this.contentStickyMenu._elementRef.nativeElement.children
      .item(0)
      .children.item(1)
      .children.item(0)
      .children.item(0)
      .children.item(pos);
  }

  /**
   * Este evento no se utiliza porque el scroll bloqueaba la UI
   * @param event
   * @returns
   */
  scrollevent = (event): void => {
    //let menuPosition =
    //  this.controlStickyMenu.nativeElement.getBoundingClientRect().top;
    let sumaCompPosition =
      this.sumaryComponent.nativeElement.getBoundingClientRect().top;
    let posiCompPosition =
      this.posiComponent.nativeElement.getBoundingClientRect().top;
    let compoCompPosition =
      this.compoComponent.nativeElement.getBoundingClientRect().top;
    let tradesCompPosition =
      this.tradesComponent.nativeElement.getBoundingClientRect().top;
    let actividadesCompPosition =
      this.actividadesComponent.nativeElement.getBoundingClientRect().top;
    let creditsCompPosition =
      this.creditsComponent.nativeElement.getBoundingClientRect().top;
    let diagnosisCompPosition =
      this.diagnosisComponent.nativeElement.getBoundingClientRect().top;
    let riskCompPosition =
      this.riskComponent.nativeElement.getBoundingClientRect().top;
    let commissionsCompPosition =
      this.commissionsComponent.nativeElement.getBoundingClientRect().top; /*
    if (menuPosition < 0) {
      this.renderer.addClass(this.stickyMenu.nativeElement, 'sticky');
    } else {
      this.renderer.removeClass(this.stickyMenu.nativeElement, 'sticky');
    }*/

    if (this.isMobile) {
      if (this.stopScrollEvent) return;

      //this.clickTabsMenu = false;
      if (sumaCompPosition != 0) {
        if (
          sumaCompPosition < event.target.clientHeight &&
          posiCompPosition > event.target.clientHeight
        ) {
          //tabIndex must be retrieved by using getSelectedTabIndex because some tabs are dynamic
          this.tabIndex = this.getSelectedTabIndex(
            PortfolioDataTabEnum.Summary
          );
          this.contentStickyMenu.selectedIndex = this.tabIndex;
          posiCompPosition =
            this.compoComponent.nativeElement.getBoundingClientRect().top;
          if (
            posiCompPosition - 100 <= event.target.clientHeight &&
            !this.positions
          ) {
            this.positions = true;
            if (this.positionsFirstLoad) {
              this.timer50.subscribe(() =>
                this.profilePortfolioService.updatePositions()
              );
            }
          }
        }
        if (
          posiCompPosition < event.target.clientHeight &&
          compoCompPosition > event.target.clientHeight
        ) {
          this.tabIndex = this.getSelectedTabIndex(
            PortfolioDataTabEnum.Positions
          );
          this.contentStickyMenu.selectedIndex = this.tabIndex;
          if (
            compoCompPosition - 100 <= event.target.clientHeight &&
            !this.compositions
          ) {
            this.compositions = true;
            //this.timer50.subscribe(() => this.profilePortfolioService.updateCompoPositions());
          }
        }
        if (
          compoCompPosition < event.target.clientHeight &&
          (tradesCompPosition > event.target.clientHeight ||
            actividadesCompPosition > event.target.clientHeight)
        ) {
          this.tabIndex = this.getSelectedTabIndex(
            PortfolioDataTabEnum.Composition
          );
          this.contentStickyMenu.selectedIndex = this.tabIndex;
          if (
            (tradesCompPosition - 100 <= event.target.clientHeight ||
              actividadesCompPosition - 100 <= event.target.clientHeight) &&
            !this.trades &&
            !this.actividades
          ) {
            this.trades = this.showActivities ? false : true;
            this.actividades = this.showActivities ? true : false;
            //this.timer50.subscribe(() => this.profilePortfolioService.updateTradePositions());
          }
        }
        if (
          (tradesCompPosition < event.target.clientHeight ||
            actividadesCompPosition < event.target.clientHeight) &&
          creditsCompPosition > event.target.clientHeight
        ) {
          this.tabIndex = this.showActivities
            ? this.getSelectedTabIndex(PortfolioDataTabEnum.Activities)
            : this.getSelectedTabIndex(PortfolioDataTabEnum.Trades);
          this.contentStickyMenu.selectedIndex = this.tabIndex;
          if (
            creditsCompPosition - 100 <= event.target.clientHeight &&
            !this.credits
          ) {
            this.credits = this.hasCredits ? true : false;
          }
        }
        if (creditsCompPosition < event.target.clientHeight) {
          this.credits = this.hasCredits ? true : false;
          this.tabIndex = this.getSelectedTabIndex(
            PortfolioDataTabEnum.Credits
          );
          this.contentStickyMenu.selectedIndex = this.tabIndex;
        }
        if (
          (tradesCompPosition < event.target.clientHeight ||
            actividadesCompPosition < event.target.clientHeight) &&
          diagnosisCompPosition > event.target.clientHeight
        ) {
          this.tabIndex = this.showActivities
            ? this.getSelectedTabIndex(PortfolioDataTabEnum.Activities)
            : this.getSelectedTabIndex(PortfolioDataTabEnum.Trades);
          this.contentStickyMenu.selectedIndex = this.tabIndex;
          if (
            diagnosisCompPosition - 100 <= event.target.clientHeight &&
            !this.diagnosis
          ) {
            this.diagnosis = this.showDiagnosis ? true : false;
          }
        }
        if (diagnosisCompPosition < event.target.clientHeight) {
          this.diagnosis = this.showDiagnosis ? true : false;
          this.tabIndex = this.getSelectedTabIndex(
            PortfolioDataTabEnum.Diagnosis
          );
          this.contentStickyMenu.selectedIndex = this.tabIndex;
        }
        if (
          (tradesCompPosition < event.target.clientHeight ||
            actividadesCompPosition < event.target.clientHeight) &&
          commissionsCompPosition > event.target.clientHeight
        ) {
          this.tabIndex = this.showActivities
            ? this.getSelectedTabIndex(PortfolioDataTabEnum.Activities)
            : this.getSelectedTabIndex(PortfolioDataTabEnum.Trades);
          this.contentStickyMenu.selectedIndex = this.tabIndex;
          if (
            commissionsCompPosition - 100 <= event.target.clientHeight &&
            !this.commissions
          ) {
            this.commissions = this.showCommissions ? true : false;
          }
        }
        if (commissionsCompPosition < event.target.clientHeight) {
          this.commissions = this.showCommissions ? true : false;
          this.tabIndex = this.getSelectedTabIndex(
            PortfolioDataTabEnum.Commissions
          );
          this.contentStickyMenu.selectedIndex = this.tabIndex;
        }
      }
    }
  };

  onTabChanged(event) {
    if (this.withClick) {
      this.loadTab(event.index);
      this.stopScrollEvent = true;
      this.contentStickyMenu.selectedIndex = event.index;
      let tabType = this.getSelectedTab(event.index);
      this.tabIndex = tabType;
      switch (tabType) {
        case PortfolioDataTabEnum.Summary:
          this.sumaryComponent.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'start',
          });
          break;
        case PortfolioDataTabEnum.Positions:
          this.posiComponent.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'start',
          });
          break;
        case PortfolioDataTabEnum.Composition:
          this.compoComponent.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'start',
          });
          break;
        case PortfolioDataTabEnum.Trades:
          this.tradesComponent.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'start',
          });
          break;
        case PortfolioDataTabEnum.Activities:
          this.actividadesComponent.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'start',
          });
          break;
        case PortfolioDataTabEnum.Credits:
          this.creditsComponent.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'start',
          });
          break;
        case PortfolioDataTabEnum.Risk:
          break;
        case PortfolioDataTabEnum.Diagnosis:
          this.diagnosisComponent.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'start',
          });
          break;
        case PortfolioDataTabEnum.Commissions:
          this.commissionsComponent.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'start',
          });
          break;
        default:
          break;
      }

      this.timer50.subscribe(() => (this.stopScrollEvent = false));
    }
    this.withClick = false;
  }

  clickTab() {
    this.withClick = true;
  }

  /**
   * Load selected component
   * @param index Tab index selected
   */
  loadTab(index: number) {
    //Index must be converted to tabType because tab items are dynamic.
    let tabType = this.getSelectedTab(index);
    if (this.isMobile) {
      //Enable all tabs in mobile view.
      this.enableAllTabs();
      //Scroll to component
      this.timer50.subscribe(() => {
        let tabSelector = '#tab' + tabType;
        if (document.querySelector(tabSelector) != null)
          document.querySelector(tabSelector).scrollIntoView({
            behavior: 'auto',
            block: 'start',
            inline: 'start',
          });
      });
    } else {
      switch (tabType) {
        case PortfolioDataTabEnum.Summary: //'sumary':
          this.sumary = true;
          this.positions = false;
          this.compositions = false;
          this.trades = false;
          this.actividades = false;
          this.credits = false;
          this.diagnosis = false;
          this.commissions = false;
          // this.updateSummary();
          break;
        case PortfolioDataTabEnum.Positions: //'positions':
          this.sumary = false;
          this.positions = true;
          this.compositions = false;
          this.trades = false;
          this.actividades = false;
          this.credits = false;
          this.diagnosis = false;
          this.commissions = false;
          // this.profilePortfolioService.updatePositions();
          break;
        case PortfolioDataTabEnum.Composition: //'compositions':
          this.sumary = false;
          this.positions = false;
          this.compositions = true;
          this.trades = false;
          this.actividades = false;
          this.credits = false;
          this.diagnosis = false;
          this.commissions = false;
          //this.timer50.subscribe(() => this.updateCompositions());
          break;
        case PortfolioDataTabEnum.Trades: //'trades':
          this.sumary = false;
          this.positions = false;
          this.compositions = false;
          this.trades = true;
          this.actividades = false;
          this.credits = false;
          this.diagnosis = false;
          this.commissions = false;
          break;
        case PortfolioDataTabEnum.Activities: //'actividades':
          this.sumary = false;
          this.positions = false;
          this.compositions = false;
          this.trades = false;
          this.actividades = true;
          this.credits = false;
          this.diagnosis = false;
          this.commissions = false;
          break;
        case PortfolioDataTabEnum.Credits: //'credits'
          this.sumary = false;
          this.positions = false;
          this.compositions = false;
          this.trades = false;
          this.actividades = false;
          this.credits = true;
          this.diagnosis = false;
          this.commissions = false;
          break;
        case PortfolioDataTabEnum.Risk:
          break;
        case PortfolioDataTabEnum.Diagnosis: //'diagnosis':
          this.sumary = false;
          this.positions = false;
          this.compositions = false;
          this.trades = false;
          this.actividades = false;
          this.credits = false;
          this.diagnosis = true;
          this.commissions = false;
          break;
        case PortfolioDataTabEnum.Commissions: //'commissions':
          this.sumary = false;
          this.positions = false;
          this.compositions = false;
          this.trades = false;
          this.actividades = false;
          this.credits = false;
          this.diagnosis = false;
          this.commissions = true;
          break;
        default:
          this.sumary = true;
          this.positions = false;
          this.compositions = false;
          this.trades = false;
          this.actividades = false;
          this.credits = false;
          this.diagnosis = false;
          this.commissions = false;
          break;
      }
    }
  }

  /**
   * Enable all tabs.
   */
  enableAllTabs() {
    this.sumary = true;
    this.positions = true;
    this.compositions = true;
    this.trades = this.showActivities ? false : true;
    this.actividades = this.showActivities ? true : false;
    this.credits = this.hasCredits;
    this.diagnosis = this.showDiagnosis;
    this.commissions = this.showCommissions;
  }

  /**
   * Retrieves the tab that matches the provided index.
   * @param tabIndex Index of the selected tab in the list
   * @returns Key than identifies the selected tab in the list
   */
  getSelectedTab(tabIndex: number): PortfolioDataTabEnum {
    var selectedTab = PortfolioDataTabEnum.Summary; //default
    var i = 0;
    //Iterate tabMap searching for the key of the selected tabIndex item
    this.tabMap.forEach((value, key) => {
      if (tabIndex == i) {
        selectedTab = key; //key stores the tab located in index tabIndex
      }
      i++;
    });
    return selectedTab;
  }

  /**
   * Retrieves the index of the tab that matches the provided tab key.
   * @param tab Key than identifies the selected tab in the list
   * @returns Index of the selected tab in the list
   */
  getSelectedTabIndex(tab: PortfolioDataTabEnum): number {
    var selectedTabIndex = 0; //default
    var i = 0;
    //Iterate tabMap searching for the key of the selected tabIndex item
    this.tabMap.forEach((value, key) => {
      if (tab == key) {
        selectedTabIndex = i;
      }
      i++;
    });
    return selectedTabIndex;
  }

  /*
  private updateSummary() {
    this.profilePortfolioService.portfolioDataSource.next(this.portfolioData);
  }*/

  private checkIfHasCredits() {
    this.profilePortfolioService.portfolioanalysis$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        if (res) {
          if (
            res.LiabilitiesValuation &&
            Math.abs(res.LiabilitiesValuation) > 0
          ) {
            this.profilePortfolioService.portfolioAnalysisHasCreditsSource.next(
              true
            );
          } else {
            this.profilePortfolioService.portfolioAnalysisHasCreditsSource.next(
              false
            );
          }
        }
      });
  }
}
